import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {AuthService} from '../../../../../firebase/src/lib/services/auth.service';
import {map} from 'rxjs';
import {ChartData} from '../../../../../shared/src/lib/components/mixed-chart/mixed-chart.component';

export enum IntervalName {
    year = 'year',
    month = 'month',
    quartal = 'quartal'
}

export enum ChartType {
    anxiety = 'anxiety',
    depression = 'depression',
    performance = 'performance'
}

export interface YAxis {
    y0: number;
    y1: number;
    label?: string;
}

export interface XAxis {
    x0: number;
    x1: number;
    label?: string;
}

export interface Datum2 {
    id: string;
    xAxis: XAxis;
    yAxis: YAxis;
    labels?: any;
    segments?: any;
    data: Datum[];
    histogram: Datum[];
}

export interface Datum {
    x: number;
    y: number;
}

export interface Depression {
    id: string;
    xAxis: XAxis;
    yAxis: YAxis;
    labels: any[];
    segments: number[][];
    data: any[];
}

export interface Anxiety {
    id: string;
    xAxis: XAxis;
    yAxis: YAxis;
    labels: string[];
    segments: number[][];
    data: any[];
}

export interface Performance {
    title?: any;
    subtitle?: any;
    score?: any;
    data: Datum2[];
}

export interface Burnout {
    title: string;
}

export interface DashboardRangeData {
    performance: Performance;
    anxiety: Anxiety;
    depression: Depression;
    burnout: Burnout;
    important_parameters: Burnout;
    details: Burnout;
    recommendations: Burnout;
}

export interface DashboardData {
    date: Date;
    month: DashboardRangeData;
}

@Injectable({
    providedIn: 'root'
})
export class ReportService {

    reportData: any = null;

    constructor(private http: HttpClient,
                private auth: AuthService,
    ) {

    }

    get report() {
        return this.reportData;
    }

    set report(data: any) {
        this.reportData = data;
    }

    fetchData() {
        const headers = new HttpHeaders({
            Authorization: `Bearer ${this.auth.userData?.stsTokenManager?.accessToken}`
        });
        return this.http.get(`${environment.apiUrl}/dashboard/company`, {
            headers
        })
            .pipe(
                map(res => {
                    this.report = res;
                    return res;
                })
            );
    }

    getDataByInterval(data: any, intervalName: IntervalName) {
        return data[intervalName];
    }

    dashboardData(data: any, type: ChartType, interval: IntervalName) {
        return this.getDataByInterval(data, interval)[type];
    }

    dataByInterval(data: any, type: string, interval: IntervalName) {
        return this.getDataByInterval(data, interval)[type];
    }

    mapPerformanceData(inputData: any, type: ChartType, interval: IntervalName): { xAxis: XAxis, yAxis: YAxis, data: ChartData[] } {
        const dashboardData = this.dashboardData(inputData, type, interval);
        if (!dashboardData) {
            return;
        }
        const {xAxis, yAxis} = dashboardData.data.find((el => el.id === 'Ukraine'));
        const barArray = dashboardData.data.find((el => el.id === 'Ukraine'))
            .histogram.map((el) => {
                return {
                    x: el.x,
                    yBar: el.y
                };
            });
        const greyArray = dashboardData.data.find((el => el.id === 'Ukraine'))
            .data.map((el) => {
                return {
                    x: el.x,
                    yGreyLine: el.y
                };
            });
        const colorArray = dashboardData.data.find((el => el.id !== 'Ukraine'))
            .data.map((el) => {
                return {
                    x: el.x,
                    yColorLine: el.y
                };
            });

        const dataMap: any = new Map();
        barArray.forEach(item => dataMap.set(item.x, item));
        colorArray.forEach(item => dataMap.set(item.x, {...dataMap.get(item.x), ...item}));
        greyArray.forEach(item => dataMap.set(item.x, {...dataMap.get(item.x), ...item}));
        const mergedArr: ChartData[] = Array.from(dataMap.values());
        return {
            data: mergedArr,
            xAxis,
            yAxis
        };
    }

    getBarValues(data: any, interval) {
        return this.dataByInterval(data, 'details', interval)
            .map((el: any) => {
                return {
                    barTitle: el.text,
                    values: Object.values(el.data)
                };
            });
        // const barValues: any = [
        //     {
        //         barTitle: 'Dysphoric Bias',
        //         values: [10, 12, 30]
        //     },
        //     {
        //         barTitle: 'Anhedonic Bias',
        //         values: [10, 20, 60]
        //     },
        //     {
        //         barTitle: 'Hypervigilance',
        //         values: [10, 20, 10]
        //     },
        //     {
        //         barTitle: 'Avoidance',
        //         values: [10, 80, 30]
        //     },
        //     {
        //         barTitle: 'Risk of Depression',
        //         values: [10, 50, 30]
        //     },
        //     {
        //         barTitle: 'Risk of Anxiety Disorder',
        //         values: [10, 20, 30]
        //     },
        //     {
        //         barTitle: 'Trouble with sleeping',
        //         values: [10, 20, 30]
        //     },
        //     {
        //         barTitle: 'Trouble completing my tasks',
        //         values: [40, 20, 10]
        //     },
        //     {
        //         barTitle: 'Easily irritable',
        //         values: [10, 20, 30]
        //     },
        //     {
        //         barTitle: 'I have anger issues',
        //         values: [10, 30, 30]
        //     },
        //     {
        //         barTitle: 'I hate myself',
        //         values: [50, 20, 30]
        //     }
        // ];
        //
        // return barValues;
    }
}
